// Duits (de-DE), kamers: zelfde vorm als kamers.nl.ts. Kioskteksten kort en eenvoudig voor
// kinderen. Wat ontbreekt valt terug op het Nederlands (nooit een rauwe sleutel op het scherm).
export const kamersDe = {
    nav: {
        rooms: 'Räume',
        cleaning: 'Putzen',
        kidLock: 'Kindersperre',
    },
    roomKind: {
        living: 'Wohnzimmer',
        bedroom: 'Schlafzimmer',
        utility: 'Hauswirtschaftsraum',
    },
    rooms: {
        title: 'Räume',
        intro: 'Jedes Tablet gehört zu einem Raum. Der Raum bestimmt, wen du auf dem Tablet siehst.',
        add: 'Raum',
        addTitle: 'Neuer Raum',
        everyone: 'Alle',
        tablets: { one: '{count} Tablet', other: '{count} Tablets' },
        noTablet: 'Noch kein Tablet',
        modeAgenda: 'Kalender und Aufgaben',
        modeLogboek: 'Putzschrank',
        open: 'Öffnen',
        back: 'Räume',
        name: 'Name',
        nameHint: 'Zum Beispiel: Zimmer von Lena und Paul',
        kind: 'Art des Raums',
        whoTitle: 'Wen siehst du auf diesem Tablet?',
        whoIntro: 'Auf einem Tablet im Schlafzimmer siehst du nur die, die dort schlafen.',
        whoAll: 'Alle',
        whoExplicit: 'Nur Bewohner',
        residents: 'Bewohner',
        residentsHint: 'Tippe auf ein Gesicht, um es an- oder auszuschalten.',
        noResidentsWarning: 'Wähle, wer hier schläft, sonst bleibt das Tablet leer.',
        noResidentsUtility: 'Ohne Bewohner kann sich jeder auf diesem Tablet selbst auswählen.',
        householdWide: 'Auch Termine für die ganze Familie zeigen',
        showTitle: 'Was zeigt das Tablet?',
        showAgenda: 'Kalender und Aufgaben',
        showAgendaHint: 'Das normale Board mit heute, der Woche und den Aufgaben.',
        showLogboek: 'Putzschrank',
        showLogboekHint: 'Große Kacheln: Wer hat Wäsche gewaschen, wer hat gesaugt?',
        a11yTitle: 'Barrierefreiheit auf dem Tablet',
        readAloud: 'Vorlesen',
        readAloudHint: 'Tippe auf ein Bild, und das Tablet liest es vor. Praktisch für alle, die noch nicht lesen.',
        textSize: 'Textgröße',
        textNormal: 'Normal',
        textLarge: 'Groß',
        textFar: 'Sehr groß',
        calmMotion: 'Ruhige Bewegung',
        calmMotionHint: 'Keine bewegten Feiern, alles erscheint ruhig.',
        sounds: 'Ton',
        tabletsTitle: 'Tablets in diesem Raum',
        tabletsEmpty: 'Hier hängt noch kein Tablet.',
        moveHere: 'Tablet hierher verschieben',
        moveChoose: 'Wähle ein Tablet',
        moved: '{name} hängt jetzt in {room}.',
        lastSeen: 'zuletzt gesehen {ago}',
        save: 'Speichern',
        saved: 'Gespeichert. Das Tablet zeigt es innerhalb einer Minute.',
        created: '{name} wurde hinzugefügt.',
        remove: 'Raum löschen',
        removeBlocked: 'Verschiebe zuerst das Tablet in einen anderen Raum.',
        removeTitle: 'Raum löschen?',
        removeBody: '{name} verschwindet. Der Verlauf bleibt gespeichert.',
        removeConfirm: 'Löschen',
        removed: '{name} wurde gelöscht.',
        lastRoom: 'Ein Haushalt behält mindestens einen Raum.',
        conflict: 'Dieser Raum wurde inzwischen von jemand anderem geändert. Wir haben die neueste Version geladen.',
        emptyTitle: 'Jeder Raum ein eigenes Board',
        emptyBody: 'Häng ein Tablet ins Schlafzimmer oder in den Hauswirtschaftsraum und wähle, wen du dort siehst.',
        notFound: 'Diesen Raum gibt es nicht (mehr).',
    },
    cleaning: {
        title: 'Putzen',
        add: 'Aufgabe',
        tabTurn: 'Wer ist dran',
        tabHistory: 'Verlauf',
        tabItems: 'Aufgaben',
        turnIntro: 'Wer eine Aufgabe am längsten nicht gemacht hat, ist dran.',
        status: { fresh: 'Gerade gemacht', soon: 'Bald', due: 'Wieder fällig' },
        every: { one: 'jeden Tag', other: 'alle {count} Tage' },
        everyWeek: 'jede Woche',
        every2Weeks: 'alle 2 Wochen',
        everyMonth: 'jeden Monat',
        lastBy: 'Zuletzt: {name}, {when}',
        never: 'Noch nie gemacht',
        turn: 'Ist dran',
        doneAction: 'Erledigt…',
        doneTitle: '{item} erledigt',
        who: 'Wer',
        when: 'Wann',
        time: 'Uhrzeit',
        whenHint: 'Rückdatieren geht bis zu 30 Tage.',
        note: 'Notiz',
        logged: '{item}: erledigt von {name}.',
        loggedNoPoints: 'Gespeichert. Keine Punkte: {name} hat es schon am {when} gemacht.',
        points: { one: '{count} Stern', other: '{count} Sterne' },
        alreadyBy: 'schon erledigt von {name}',
        deleted: 'gelöscht',
        source: { kiosk: 'auf dem Tablet', app: 'in der App' },
        removeLog: 'Löschen',
        removeLogTitle: 'Diesen Eintrag löschen?',
        removeLogBody: '{name} bekommt die Punkte dann nicht mehr.',
        removeLogConfirm: 'Löschen',
        logRemoved: 'Gelöscht.',
        negativeTitle: 'Punktestand wird negativ',
        negativeBody: '{name} hat die Punkte schon ausgegeben. Trotzdem löschen?',
        historyEmptyTitle: 'Noch nichts erledigt',
        historyEmptyBody: 'Sobald jemand etwas einträgt, siehst du es hier.',
        filterAll: 'Alle',
        filterLabel: 'Nach Mitglied filtern',
        showDeleted: 'Auch gelöschte zeigen',
        today: 'Heute',
        yesterday: 'Gestern',
        itemsIntro: 'Pro Ort die Aufgaben und wie oft sie wiederkommen.',
        noLocation: 'Ohne Ort',
        edit: 'Bearbeiten',
        archive: 'Entfernen',
        archived: '{name} wurde entfernt.',
        editorNew: 'Neue Aufgabe',
        editorEdit: 'Aufgabe bearbeiten',
        itemName: 'Name',
        itemNameHint: 'Kurz und klar, zum Beispiel: Waschmaschine anstellen',
        icon: 'Symbol',
        location: 'Ort',
        newLocation: 'Neuer Ort…',
        newLocationName: 'Name des Orts',
        howOften: 'Wie oft',
        customDays: 'Anzahl Tage',
        pointsLabel: 'Punkte',
        pointsHint: 'Höchstens einmal pro Zeitraum, auch wenn mehrere es machen.',
        participants: 'Wer macht mit',
        participantsHint: 'Niemand gewählt = alle.',
        saved: 'Gespeichert.',
        conflict: 'Diese Aufgabe wurde inzwischen geändert. Wir haben die neueste Version geladen.',
        emptyTitle: 'Noch keine Putzaufgaben',
        emptyBody: 'Fang mit etwas an, das oft wiederkommt, zum Beispiel die Waschmaschine.',
        emptyAction: 'Aufgabe hinzufügen',
        suggestions: 'Oder fang mit einem Beispiel an',
        suggest: {
            laundry: 'Waschmaschine anstellen',
            hang: 'Wäsche aufhängen',
            bath: 'Bad putzen',
            vacuum: 'Staubsaugen',
            plants: 'Pflanzen gießen',
        },
        loadError: 'Etwas ist schiefgelaufen. Versuch es noch einmal.',
        retry: 'Erneut versuchen',
    },
    kidLock: {
        title: 'Kindersperre',
        intro: 'Praktisch, wenn Geschwister die Aufgaben der anderen abhaken. Standardmäßig aus; die Sperre gilt nur auf dem Tablet.',
        none: 'Keine Sperre',
        pin: 'PIN',
        picture: 'Bildercode',
        since: 'seit {when}',
        waiting: 'wartet bis {time}',
        set: 'Einrichten',
        change: 'Ändern',
        sheetTitle: 'Kindersperre für {name}',
        kindLabel: 'Art der Sperre',
        noneHint: 'Alle können auf dem Tablet für {name} tippen.',
        pinHint: '4 Ziffern, die sich {name} merkt.',
        pictureHint: '4 Bilder in einer Reihenfolge. Lass {name} sie selbst wählen.',
        pinLabel: 'PIN (4 Ziffern)',
        pinRepeat: 'Noch einmal',
        pinMismatch: 'Die beiden PINs stimmen nicht überein.',
        pinInvalid: 'Wähle genau 4 Ziffern.',
        pictureChosen: 'Gewählt: {count} von 4',
        pictureClear: 'Löschen',
        pictureInvalid: 'Wähle 4 Bilder.',
        pictureSlot: 'Bild {n}',
        saved: 'Die Kindersperre von {name} wurde geändert.',
        removed: 'Die Kindersperre von {name} ist aus.',
        emptyTitle: 'Noch keine Kinder',
        emptyBody: 'Füge zuerst deine Kinder bei Mitglieder hinzu.',
        about: 'Vergessen? Leg hier einen neuen Code fest. Fünfmal falsch auf dem Tablet heißt: kurz warten.',
    },
    picture: {
        fox: 'Fuchs',
        cat: 'Katze',
        rabbit: 'Hase',
        bear: 'Bär',
        panda: 'Panda',
        owl: 'Eule',
        lion: 'Löwe',
        frog: 'Frosch',
        turtle: 'Schildkröte',
    },
    voice: {
        dictate: 'Sprechen',
        listening: 'Ich höre zu…',
        stop: 'Stopp',
        heard: 'Verstanden: {text}',
        failed: 'Das habe ich nicht verstanden. Tipp es lieber ein.',
    },
    kiosk: {
        entry: 'Putzen',
        title: 'Putzschrank',
        back: 'Zurück',
        who: 'Wer hat es gemacht?',
        hold: 'Halte dein Gesicht fest, bis der Kreis voll ist',
        holdShort: 'Festhalten',
        status: { fresh: 'Gerade gemacht', soon: 'Bald', due: 'Wieder fällig' },
        never: 'noch nie',
        justNow: 'gerade',
        minutesAgo: { one: '{count} Min.', other: '{count} Min.' },
        hoursAgo: { one: '{count} Std.', other: '{count} Std.' },
        daysAgo: { one: '1 Tag', other: '{count} Tage' },
        goodJob: 'Gut gemacht, {name}!',
        /** Rustig, buiten het thema Kinderen (geen lof, geen sterren). */
        goodJobCalm: 'Erledigt von {name}',
        stars: { one: '+{count} Stern', other: '+{count} Sterne' },
        alreadyDone: 'Schon gemacht von {name} um {time}. Trotzdem danke!',
        alreadyDoneCalm: 'Schon gemacht von {name} um {time}.',
        oops: 'Hoppla',
        undone: 'Wieder entfernt',
        other: 'Etwas anderes…',
        otherTitle: 'Was hast du gemacht?',
        sayIt: 'Sag es einfach',
        emptyTitle: 'Noch keine Aufgaben',
        emptyBody: 'Mama oder Papa legt sie in der App an.',
        notSaved: 'Noch nicht gespeichert, wir versuchen es gleich noch mal.',
        close: 'Schließen',
        lockAskPin: '{name}, wie ist dein Code?',
        lockAskPicture: '{name}, welche Bilder?',
        lockWrong: 'Noch mal',
        lockWait: 'Kurz warten…',
        lockDigit: 'Ziffer {digit}',
        lockErase: 'Löschen',
        lockProgress: '{count} von 4',
        adhoc: {
            windows: 'Fenster putzen',
            sweep: 'Fegen',
            trash: 'Müll rausbringen',
            dishes: 'Abwaschen',
            'tidy-up': 'Aufräumen',
            'water-plants': 'Pflanzen gießen',
            recycling: 'Glas und Papier',
            'make-bed': 'Bett beziehen',
        },
    },
    speech: {
        at: 'um {time}',
        points: { one: '{count} Stern', other: '{count} Sterne' },
    },
    a11y: {
        skipToContent: 'Zum Inhalt',
        mainNav: 'Hauptnavigation',
    },
};
//# sourceMappingURL=kamers.de.js.map